import { get } from 'lodash';
import { SANTA_MEMBERS_APP_ID } from '@wix/communities-forum-universal/dist/src/constants/appsConfig';

export const isMemberAreaInstalled = (state) =>
  get(state.communitiesContext, `${SANTA_MEMBERS_APP_ID}.isInstalled`, true);
